import { render, staticRenderFns } from "./HolidayManagement.vue?vue&type=template&id=0524baf0"
import script from "./HolidayManagement.vue?vue&type=script&lang=js"
export * from "./HolidayManagement.vue?vue&type=script&lang=js"
import style0 from "./HolidayManagement.vue?vue&type=style&index=0&id=0524baf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports